var unfabled;
(function($) {
  "use strict";
  unfabled = (function() {
    return {
      init: function() {
        // Header
        this.announcement();
        this.fixedHeader();
        this.account();
        this.search();
        this.mobileMenu();
        this.canvasCart();
        this.cartProducts();

        // Home
        this.hero();
        this.press();
        this.homeProducts();
        this.homeProductsfeed();

        this.banners();
        this.banner_multiple_images();
        this.reviews();
        this.latestNews();
        this.homeProductsTab();
        this.featuredProductsTab();
        this.categories();
        this.reviews2();
        this.instagram();

        // Collection
        this.collection();
        this.collectionFilter();

        // Product
        this.productImages();
        this.productQuantity();
        this.productForm();
        this.relatedProducts();
        this.recentlyViewed();

        // Pages
        this.rewardsPage();
        this.blogPage();
        this.shareArticle();
        this.quiz();
        this.helpPages();

        // Utilites
        this.matchHeight();
        this.video();
        this.accordion();
        this.zoom();
        this.aos();
        this.gallery();
        this.quickView();

        $(window).on('resize', this.fixedHeader)
      },

      // Header
      announcement: function() {
        var length = $(".js-announcement-item").length;
        let delay = $(".announcement").attr("data-delay") ? $(".announcement").attr("data-delay") : 4000;
        var current = 1;
        if(length > 1) {
          setInterval(function () {
            var translate = current * 100;
            if(current < length) {
              current++;
              $(".js-announcement-item").css("transform", "translateY(-" + translate + "%)");
            } else {
              current = 1;
              $(".js-announcement-item").addClass("no-transition").addClass("no-transform");
              setTimeout(function () {
                $(".js-announcement-item").removeClass("no-transition").removeClass("no-transform").css("transform", "none");
              }, 1000);
            }
          }, delay);
        }
      },

      fixedHeader: function() {
        $(".js-wrap-header").css("height", $(".js-header").outerHeight());
        //$(".js-header").addClass("fixed-header");
      },

      account: function() {
        $(".js-toggle-account").click(function () {
          $(this).toggleClass("active");
          $(".js-login").toggleClass("active");
          $(".js-body").toggleClass("active-modal");
          return false;
        });
        $(".js-go-to-canvas-forgotten-password").click(function () {
          $(".js-login-canvas-login").addClass("d-none");
          $(".js-login-canvas-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login-canvas").click(function () {
          $(".js-login-canvas-login").removeClass("d-none");
          $(".js-login-canvas-forgotten-password").addClass("d-none");
          $(".js-login-canvas-register").addClass("d-none")
          return false;
        });
        $(".js-go-to-canvas-register").click(function () {
          $(".js-login-canvas-login").addClass("d-none");
          $(".js-login-canvas-forgotten-password").addClass("d-none");
          $(".js-login-canvas-register").removeClass("d-none")
          return false;
        });
        $(".js-go-to-forgotten-password").click(function () {
          $(".js-login-login").addClass("d-none");
          $(".js-login-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login").click(function () {
          $(".js-login-login").removeClass("d-none");
          $(".js-login-forgotten-password").addClass("d-none");
          return false;
        });
      },

      search: function() {
        $(".js-open-search").click(function () {
          $(".js-search").addClass("active");
          $(".js-body").addClass("active-modal");
          setTimeout(function () {
            $(".js-search-input").focus();
          }, 200);
          return false;
        });
        $(".js-close-search").click(function () {
          $(".js-search").removeClass("active");
          $(".js-body").removeClass("active-modal");
          return false;
        });
        $(".js-load-search-counter").each(function () {
          var url = $(this).closest("a").attr("href");
          var that = $(this);
          $.ajax({
            type: "get",
            url: url,
            success: function(result) {
              $(that).html(' (' + $(result).find(".js-collection-items").attr("data-products-count") + ')');
            }
          })
        });
      },

      mobileMenu: function() {
        $(".js-open-mobile-menu").click(function () {
          if($(this).hasClass("active")) {
            $("body").css("overflow", "visible").removeClass("active-mobile-menu");
          } else {
            $("body").css("overflow", "hidden").addClass("active-mobile-menu");
            $(".js-body").addClass("active-modal");
          }
          $(".js-mobile-menu").addClass("active");
          var height = $(".js-mobile-menu").height();
          $(".js-match-mobile-menu-height").css("height", height);
          return false;
        });
        $(".js-close-mobile-menu").click(function () {
          $("body").css("overflow", "visible").removeClass("active-mobile-menu");
          $(".js-mobile-menu").removeClass("active");
          $(".js-body").removeClass("active-modal");
          return false;
        });
        $(".js-carousel-mobile-menu").owlCarousel({
          loop: false,
          margin: 14,
          nav: false,
          items: 1,
          dots: false,
          autoplay: false
        });
        $(".js-go-to-mobile-submenu").click(function () {
          $(".js-carousel-mobile-menu").trigger('to.owl.carousel', 1);
          var index = $(this).attr("data-index");
          $(".js-mobile-menu-second-step").addClass("d-none");
          $(".js-mobile-menu-second-step[data-index='" + index + "']").removeClass("d-none");
          return false;
        });
        $(".js-go-to-mobile-first-menu").click(function () {
          $(".js-carousel-mobile-menu").trigger('to.owl.carousel', 0);
          return false;
        });
      },

      canvasCart: function() {
        $(".js-open-canvas-cart").on("click", function() {
          $(".js-body").addClass("active-modal");
          $(".js-canvas-cart").addClass("active");
          $("body").css("overflow", "hidden");

  

          return false;
        });
        $("body").on("click", ".js-close-canvas-cart, .js-continue-shopping", function() {
          $(".js-canvas-cart").removeClass("active");
          $(".js-body").removeClass("active-modal");
          $("body").css("overflow", "visible");
          return false;
        });
        $("body").on("click", ".js-delete-product-canvas", function() {
          var line = $(this).attr("data-line");
          var quantity = 0;
          $(".js-cart-content").addClass("is-loading");
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { line: line, quantity: quantity },
            success: function() {
              unfabled.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              unfabled.refreshCart();
            }
          });
          return false;
        });
        $("body").on("click", ".js-change-quantity", function() {
          var variantId = parseInt($(this).attr("data-variant-id"));
          var line = $(this).attr("data-line");
          var quantity = parseInt($(this).attr("data-quantity"));
          $(".js-cart-content").addClass("is-loading");
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { line: line, quantity: quantity },
            success: function() {
              unfabled.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              unfabled.refreshCart();
            }
          });
          return false;
        });
        $("body").on("input", ".js-cart-note", function () {
          $(".js-cart-note-form").val($(this).val());
        });
      },

      cartProducts: function() {
        $(".js-mobile-cart-products-carousel").owlCarousel({
          loop: false,
          margin: 10,
          nav: false,
          items: 2,
          dots: false
        });
      },

      // Home
      hero: function() {
        setTimeout(function () {
          $(".js-hero-content").addClass("active");
        }, 1000);
      },

      press: function() {
        $(".js-press-carousel").owlCarousel({
          loop: true,
          margin: 22,
          nav: false,
          items: 5,
          dots: false,
          autoplay: true,
          responsive: {
            0:{
              items: 2
            },
            768:{
              items: 3
            },
            992: {
              items: 4
            },
            1200:{
              items: 5
           }
          }


        });
      },

      homeProducts: function() {



      },

        homeProductsfeed: function() {

        $(".js-main-home-products").owlCarousel({
            loop: false,
            margin: 20,
            nav: true,
            items: 4,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 2,
                margin: 10
              },
              992: {
                items: 3,
                margin: 20
              },
              1200: {
                items: 4,
                margin: 20
              },
              1600: {
                items: 5
              }
            }

        });


        /*if($(".js-body").hasClass("body-full-width")) {
          $(".js-home-products").owlCarousel({
            loop: false,
            margin: 20,
            nav: true,
            items: 4,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 2,
                margin: 10
              },
              992: {
                items: 3,
                margin: 20
              },
              1200: {
                items: 4,
                margin: 20
              },
              1600: {
                items: 5
              }
            }
          });

           $(".js-main-home-products").owlCarousel({
            loop: false,
            margin: 20,
            nav: true,
            smartSpeed:200,
            items: 4,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 2,
                margin: 10
              },
              992: {
                items: 3,
                margin: 20
              },
              1200: {
                items: 4,
                margin: 20
              },
              1600: {
                items: 5
            }
          }
        });

        } else {
          $(".js-home-products").owlCarousel({
            loop: false,
            margin: 20,
            nav: true,
            items: 4,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 2,
                margin: 10
              },
              992: {
                items: 3,
                margin: 20
              },
              1200: {
                items: 4,
                margin: 20
              }
            }
          });
          $(".js-main-home-products").owlCarousel({
            loop: false,
            margin: 20,
            nav: true,
            smartSpeed:200,
            items: 4,
            dots: false,
            autoplay: false,
            responsive: {
              0:{
                items: 2,
                margin: 10
              },
              992: {
                items: 3,
                margin: 20
              },
              1200: {
                items: 4,
                margin: 20
              }
            }
        });
        }*/
      },

      banners: function() {
        $(".js-banners-carousel").owlCarousel({
          loop: false,
          margin: 20,
          nav: true,
          items: 5,
          dots: false,
          autoplay: false,
          responsive: {
            0:{
              items: 2,
              margin: 13
            },
            768: {
              items: 2,
              margin: 13
            },
            992: {
              items: 4,
              marign: 20
            },
            1200: {
              items: 5,
              margin: 20
            }
          }
        });
      },

      banner_multiple_images: function() {
        $(".js-banners-multiple-images-carousel").owlCarousel({
          loop: false,
          margin: 12,
          nav: true,
          items: 4,
          dots: false,
          autoplay: false,
          responsive: {
            0:{
              items: 1,
              margin: 12
            },
            768: {
              items: 2,
              margin: 12
            },
            992: {
              items: 4,
              marign: 12
            },
            1200: {
              items: 4,
              margin: 12
            }
          }
        });
      },

      reviews: function() {
        $(".js-reviews-carousel").owlCarousel({
          loop: true,
          margin: 20,
          nav: false,
          items: 1,
          dots: true,
          autoplay: false,
          //animateIn: 'fadeIn',
          //animateOut: 'fadeOut',
          autoHeight: true
        });
      },

      latestNews: function() {
        $(".js-carousel-latest-news").owlCarousel({
          loop: false,
          margin: 24,
          nav: true,
          items: 2,
          dots: false,
          autoplay: false,
          responsive: {
            0:{
              items: 1,
              margin: 24
            },
            768: {
              items: 2,
              margin: 24
            },
            992: {
              margin: 46,
              items: 2
            }
          }
        });
      },

      homeProductsTab: function() {
        $(".js-change-product-tab").click(function () {
          $(this).closest(".js-home-products-tab").find(".js-change-product-tab").removeClass("active");
          $(this).closest(".js-home-products-tab").find(".home-products__action").removeClass("active");
          $(this).addClass("active");
          var index = $(this).attr("data-index");
          $(this).closest(".js-home-products-tab").find(".js-home-product-tab").removeClass("active");
          $(this).closest(".js-home-products-tab").find(".js-home-product-tab[data-index='" + index + "']").addClass("active");

          $(this).closest(".js-home-products-tab").find(".home-products__action[data-index='" + index + "']").addClass("active");

          return false;
        });

        //  $(".js-home-products").owlCarousel({
        //     loop: false,
        //     margin: 20,
        //     nav: true,
        //     items: 4,
        //     dots: false,
        //     autoplay: false,
        //     responsive: {
        //       0:{
        //         items: 2,
        //         margin: 8
        //       },
        //       992: {
        //         items: 3,
        //         margin: 20
        //       },
        //       1200: {
        //         items: 4,
        //         margin: 20
        //       },
        //       1600: {
        //         items: 5
        //       }
        //     }
        //   });

        $(".js-home-products").owlCarousel({
  loop: false,
  margin: 20,
  nav: true,
  items: 4,
  dots: false,
  autoplay: false,

  touchDrag: true,
  mouseDrag: true,
  pullDrag: true,
  freeDrag: false,

  smartSpeed: 600,           // smoother slide speed
  fluidSpeed: 600,           // matches smartSpeed
  dragEndSpeed: 400,         // slows end of drag for smooth feel
  slideTransition: 'cubic-bezier(0.25, 0.1, 0.25, 1)', // smooth easing

  responsiveRefreshRate: 50, // faster reaction to drag
  responsiveBaseElement: window,

  responsive: {
    0: { items: 2, margin: 8 },
    992: { items: 3, margin: 20 },
    1200: { items: 4, margin: 20 },
    1600: { items: 5 }
  },

  onInitialized: function() { gpuFix(); },
  onDragged: function() { gpuFix(); }
});

function gpuFix() {
  document.querySelectorAll('.js-home-products .owl-item').forEach(function(el){
    el.style.transform = 'translateZ(0)';
    el.style.backfaceVisibility = 'hidden';
  });
}


      },

      featuredProductsTab: function() {
        $(".js-change-product-tab").click(function () {
          $(this).closest(".js-featured-products-tab").find(".js-change-product-tab").removeClass("active");
          $(this).closest(".js-featured-products-tab").find(".home-products__action").removeClass("active");
          $(this).addClass("active");
          var index = $(this).attr("data-index");
          $(this).closest(".js-featured-products-tab").find(".js-home-product-tab").removeClass("active");
          $(this).closest(".js-featured-products-tab").find(".js-home-product-tab[data-index='" + index + "']").addClass("active");

          $(this).closest(".js-featured-products-tab").find(".home-products__action[data-index='" + index + "']").addClass("active");

          return false;
        });

        $(".js-featured-products").owlCarousel({
            loop: false,
            margin: 20,
            nav: true,
            items: 4,
            dots: false,
            autoplay: false,
            stagePadding: 0,
            responsive: {
              0:{
                items: 2,
                margin: 8
              },
              391:{
                items: 2,
                margin: 10
              },
              992: {
                items: 3,
                margin: 20
              },
              1200: {
                items: 4,
                margin: 20
              },
              1600: {
                items: 5
              }
            }
          });

      },


      categories: function() {
        $(".js-toggle-category").hover(function () {
          if(!$(this).hasClass("show") && $(window).outerWidth() > 991) {
            $(".js-toggle-category").removeClass("active").removeClass("show");
            $(this).addClass("active");
            var that = $(this);
            setTimeout(function () {
              $(that).addClass("show");
            }, 10);
            var index = $(this).attr("data-index");
            $(".js-category").removeClass("active");
            $(".js-category[data-index='" + index + "']").addClass("active");
          }
        });
        $(".js-toggle-category").click(function () {
          if($(window).outerWidth() < 992) {
            $(".js-toggle-category").removeClass("active").removeClass("show");
            $(this).addClass("active");
            var that = $(this);
            setTimeout(function () {
              $(that).addClass("show");
            }, 10);
            var index = $(this).attr("data-index");
            $(".js-category").removeClass("active");
            $(".js-category[data-index='" + index + "']").addClass("active");
            return false;
          }
        });
      },

      reviews2: function() {
        $(".js-reviews-2-carousel").owlCarousel({
          loop: true,
          margin: 26,
          nav: false,
          items: 1,
          dots: false,
          autoplay: true,
          responsive: {
            0:{
              items: 1
            },
            768: {
              items: 2
            },
            992: {
              items: 1
            }
          }
        });
      },

      instagram: function() {
        $(".js-instagram-feed-carousel").owlCarousel({
          loop: true,
          margin: 20,
          nav: false,
          items: 2,
          dots: false,
          autoplay: true,
          responsive: {
            0:{
              items: 4,
              margin: 12
            },
            768: {
              items: 4,
              margin: 12
            },
            992: {
              items: 5,
              margin: 20
            },
            1200: {
              margin: 20,
              items: 6
            },
            1800: {
              items: 7
            }
          }
        });
      },

      // Collection
      collection: function() {
        $("body").on("click", ".js-collection-next-page", function () {
          var href = $(this).attr("href");
          $(".js-collection-action").remove();
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $('.js-collection-row').append($(data).find('.js-collection-row').html());
            unfabled.matchHeight();
            setTimeout(function () {
              unfabled.matchHeight();
            }, 1000);
          });
          return false;
        });
      },

      collectionFilter: function() {
        $(".js-toggle-filter-widget").click(function() {
          $(this).parent().parent().find(".js-filter-widget").removeClass("current");
          $(this).parent().toggleClass("active").addClass("current");
          $(this).parent().find(".js-filter-widget-content").slideToggle(500);
        });

        $(".js-filter-widget.active").each(function () {
          $(this).find(".js-filter-widget-content").slideToggle(500);
        });

        Shopify.queryParams = {};
        Shopify.queryParams.sort_by = $(".js-sort-by").attr("data-value");
        var tags = [];
        $("input.tag").each(function () {
          if($(this).is(":checked")) {
            tags.push($(this).attr("value"));
          }
        });
        Shopify.queryParams.constraint = tags.join("+");

        function filterCreateUrl() {
          if($(".js-collection-items").hasClass("search2")) {
            return $(".js-collection-items").attr("data-url") + "&sort_by=" + Shopify.queryParams.sort_by;
          } else {
            if(Shopify.queryParams.constraint == '') {
              return $(".js-collection-items").attr("data-url") + "?sort_by=" + Shopify.queryParams.sort_by;
            } else {
              return $(".js-collection-items").attr("data-url") + "/" + Shopify.queryParams.constraint + "?sort_by=" + Shopify.queryParams.sort_by;
            }
          }
        }

        function filterGetContent(url) {
          $.ajax({
            type: "get",
            url: url,
            beforeSend: function() {
              $(".js-collection").addClass("loading");
            },
            success: function(result) {
              var title = result.match("<title>(.*?)</title>")[1];
              History.pushState({
                param: Shopify.queryParams
              }, title, url);
              $(".js-collection").html($(result).find(".js-collection").html());
              unfabled.matchHeight();
              setTimeout(function () {
                unfabled.matchHeight();
              }, 1000);
              $(".js-collection").removeClass("loading");
            },
            error: function() {
              $(".js-collection").removeClass("loading");
            }
          })
        }

        $("body").on("click", ".js-open-sort-by", function(y) {
          $(".js-sort-by-dropdown, .js-open-sort-by").toggleClass("active");
          return false;
        });

        $("body").on("click", ".js-change-sort-by", function(y) {
          Shopify.queryParams.sort_by = $(this).attr("data-value");
          filterGetContent(filterCreateUrl());
          $(".js-sort-by").html($(this).html());
          $(".js-sort-by-dropdown, .js-open-sort-by").removeClass("active");
          return false;
        });

        $("body").on("change", ".js-change-mobile-sort-by", function(y) {
          $(".js-change-sort-by[data-index='" + $(this).val() + "']").click();
        });

        $("input.tag").change(function () {
          if($(this).is(":checked")) {
            $(this).parent().parent().parent().find("input.tag").prop("checked", false);
            $(this).prop("checked", true);
          } else {
            $(this).parent().parent().parent().find("input.tag").prop("checked", false);
          }
          var tags = [];
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          return false;
        });

        setInterval(function () {
          var tags_status = false;
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags_status = true;
            }
          });
          if(tags_status == true) {
            $(".js-wrap-reset-filters").show();
          } else {
            $(".js-wrap-reset-filters").hide();
          }
        }, 500);

        $(".js-apply-filters").click(function () {
          var tags = [];
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          $(".js-filter").removeClass("active");
          $("body").css("overflow", "visible");
          return false;
        });

        $(".js-reset-filters").click(function () {
          var tags = [];
          $(this).parent().parent().find("input.tag").prop("checked", false);
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          $(".js-filter").removeClass("active");
          $("body").css("overflow", "visible");
          return false;
        });

        $("body").on("click", ".js-open-mobile-filter", function () {
          $(".js-filter").addClass("active");
          $("body").css("overflow", "hidden");
        });

        $("body").on("click", ".js-close-mobile-filter", function () {
          $(".js-filter").removeClass("active");
          $("body").css("overflow", "visible");
        });
      },

      // Product
      productImages: function() {
        $(".js-mobile-product-images").owlCarousel({
          loop: false,
          margin: 8,
          nav: false,
          dots: true,
          items: 1
        });
        if(!$(".js-product-thumbnails-carousel").hasClass("slick-initialized")) {
          $(".js-product-thumbnails-carousel").slick({
            slidesToShow: 6,
            slidesToScroll: 6,
            arrows: true,
            dots: false,
            vertical: true,
            verticalSwiping: true,
            infinite: false,
            responsive: [
              {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 6,
                  slidesToScroll: 6
                }
              },
              {
                breakpoint: 1298,
                settings: {
                  slidesToShow: 5,
                  slidesToScroll: 5
                }
              },
              {
                breakpoint: 1098,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4
                }
              }
            ]
          });
        }
        $("body").on("click", ".js-product-thumbnail-image", function () {
          $(".js-product-thumbnail-image").removeClass("active");
          $(this).addClass("active");
          $(".js-product-image").removeClass("active");
          $(".js-product-image[data-id='" + $(this).attr("data-id") + "']").addClass("active");
          return false;
        });
        $(".js-product-next-image").click(function () {
          if($(".thumbnail.active + .thumbnail").length > 0) {
            $(".thumbnail.active + .thumbnail").click();
          } else {
            $(".thumbnail").eq(0).click();
          }
        });
        $(".js-product-prev-image").click(function () {
          var id = $(".thumbnail.active").attr("data-id");
          if(id == 1) {
            $(".thumbnail:last-child").click();
          } else {
            $(".thumbnail").eq(id-2).click();
          }
        });
        setTimeout(function () {
          $(".zoomit-ghost").each(function () {
            $(this).on("mousemove", function (e) {
              var positionLeft = e.pageX - $(this).offset().left - 35;
              var positionTop = e.pageY - $(this).offset().top - 35;
              $('.js-product-custom-cursor').addClass("active");
              $('.js-product-custom-cursor').css({ left: positionLeft, top: positionTop })
            }).mouseleave(function () {
              $('.js-product-custom-cursor').removeClass("active");
            });
          });
        }, 500);
      },

      productQuantity: function() {
        $(".js-quantity-up").click(function () {
          var q_val_up = parseInt($(this).parent().find("input").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          $(this).parent().find("input").val(q_val_up+1).keyup();
          return false;
        });

        $(".js-quantity-down").click(function () {
          var q_val_up = parseInt($(this).parent().find("input").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          if(q_val_up > 1) {
            $(this).parent().find("input").val(q_val_up-1).keyup();
          }
          return false;
        });
      },

      productForm: function() {
        function variants(productId) {
          var data = JSON.parse(document.getElementById('ProductJson' + productId + '').innerHTML);
          var selectCallback = function(variant, selector) {
            var that = $(".js-product[data-product-id='" + productId + "']");
            if (variant) {
              if (variant.available) {
                $(that).find(".js-product-add-to-cart").removeClass("d-none");
                $(that).find(".js-product-out-of-stock").addClass("d-none");
                $(that).find(".js-label").removeClass("d-none");
                $(that).find(".js-sold-out-label").addClass("d-none")
              } if (variant) {
  if (variant.available) {
    $(that).find(".js-product-add-to-cart").removeClass("d-none");
    $(that).find(".js-product-out-of-stock").addClass("d-none");
    $(that).find(".js-label").removeClass("d-none");
    $(that).find(".js-sold-out-label").addClass("d-none");
  } else {
    $(that).find(".js-product-add-to-cart").addClass("d-none");
    $(that).find(".js-product-out-of-stock").removeClass("d-none");

    if (productId == "15605326741887") { 
        $(that).find(".js-label").removeClass("d-none"); 
        $(that).find(".js-sold-out-label").addClass("d-none");
    } else {
        $(that).find(".js-label").addClass("d-none"); 
        $(that).find(".js-sold-out-label").removeClass("d-none");
    }
  }
}
              if(variant.compare_at_price > variant.price) {
                $(that).find(".js-price-old").removeClass("d-none").html(Shopify.formatMoney(variant.compare_at_price));
                $(that).find(".js-price-new").removeClass("d-none").html(Shopify.formatMoney(variant.price)).addClass("product-price__new--with-old");
              } else {
                $(that).find(".js-price-old").addClass("d-none")
                $(that).find(".js-price-new").removeClass("d-none").removeClass("product-price__new--with-old").html(Shopify.formatMoney(variant.price));
              }
              if(variant.featured_image !== null) {
                var position = variant.featured_image.position;
                $(".js-mobile-product-images").trigger('to.owl.carousel', position - 1);
                $(".js-product-thumbnail-image[data-id='" + position + "']").click();
              }
            } else {
              $(that).find(".js-product-add-to-cart").addClass("d-none");
              $(that).find(".js-product-out-of-stock").removeClass("d-none");
            }
            $(".js-current-product-quantity").attr("data-quantity", $(".js-current-variant option:selected").attr("data-quantity"));
            $(".js-current-product-quantity").find("span").html($(".js-current-variant option:selected").attr("data-quantity"));
          }
          jQuery(function($) {
            if($("#product-select-" + productId + "").length > 0) {
              new Shopify.OptionSelectors("product-select-" + productId + "", { product: data , onVariantSelected: selectCallback, enableHistoryState: true });
            }
          });
        }

        $(".js-product").each(function () {
          variants($(this).attr("data-product-id"));
        });

        $(document).click(function(event) {
          if (!$(event.target).closest(".js-product-option").length) {
            $(".js-product-option-content").removeClass("active");
          }
        });

        $(".js-change-product-option").click(function () {
          $(this).parent().parent().find("li").removeClass("active");
          $(this).parent().addClass("active");
          var option = $(this).parent().parent().attr("data-option");
          var value = $(this).attr("data-value");
          var productId = $(this).attr("data-product-id");
          $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          $(this).closest(".js-product-option").find(".js-product-option-content").removeClass("active");
          $(this).closest(".js-product-option").find(".js-toggle-product-option span").html(value);
          $(".js-product[data-product-id='" + productId + "'] .js-sticky-bar .js-toggle-product-option").html(value);
          return false;
        });

        $(".js-product-mobile-option").change(function () {
          var option = $(this).attr("data-option");
          var value = $(this).val();
          $(".js-product-option-content[data-option='" + option + "'] a[data-value='" + value + "']").click();
        });

        $(".js-toggle-product-option").click(function () {
          $(this).closest(".js-product-option").find(".js-product-option-content").toggleClass("active");
        });

$("body").off("click.unfabledAddToCart").on("click.unfabledAddToCart", ".js-add-to-cart", function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  const $btn = $(this);
  const form = $btn.closest('form');
  const formData = form && new FormData(form[0]);
  
  if ($btn.data("adding")) return;
  
  $btn.data("adding", true).addClass("is-loading");
  
  let quantity;
  let variantId;
  
  if ($btn.hasClass("variant")) {
    variantId = Number($btn.attr("data-variant-id"));
  } else if (!form) {
    /**
     * If there is no form, try to find the data manually.
     */
    const productId = $btn.attr("data-product-id");
    quantity =
    parseInt($(".js-product[data-product-id='" + productId + "'] .js-quantity-field").val(), 10) || 1;
    
    variantId = Number($(".js-product[data-product-id='" + productId + "'] #product-select-" + productId).val());
  }
  
  if ((form && !formData.has('id')) || (!form && (!variantId || isNaN(variantId)))) {
    $btn.removeData("adding").removeClass("is-loading");
    return;
  }

  const sellingPlan =
    form && form.find(".appstle_sub_widget").attr("data-selected-selling-plan") || undefined;

  /**
   * Form data overrides.
   */
  if (form && variantId) formData.set('id', variantId);
  if (form && quantity) formData.set('quantity', quantity);
  if (form && sellingPlan) formData.set('selling_plan', sellingPlan);

  $.ajax({
    type: 'POST',
    url: '/cart/add',
    dataType: 'json',
    data: formData,
    processData: false,
    contentType: false,
  })
    .done(function () {
      // 1) Close YOUR product popup (quick view)
      $(".js-quickview-popup").removeClass("active");
      // If your popup adds body locking, also remove it:
      $(".js-body").removeClass("active-modal");
      $("body").css("overflow", "visible");

      // 2) Rebuy: force a cart refresh so it dispatches rebuy:cart.change
      // This fixes timing issues where Rebuy didn't catch the AJAX call.
      if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetchCart === "function") {
        Rebuy.Cart.fetchCart(function(cart) {
  updateCartCounter(cart);
});
      } else {
        // If Rebuy isn't ready yet, retry once shortly after
        setTimeout(function () {
          if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetchCart === "function") {
            Rebuy.Cart.fetchCart(function(cart) {
  updateCartCounter(cart);
});
          }
        }, 250);
      }
    })
    .fail(function (xhr) {
      const msg =
        (xhr.responseJSON && (xhr.responseJSON.description || xhr.responseJSON.message)) ||
        "Add to cart failed.";
      alert(msg);
    })
    .always(function () {
      $btn.removeData("adding").removeClass("is-loading");
    });
});
        $("body").on("click", ".js-add-to-cart-grid", function () {
          $(".js-cart-content").addClass("is-loading");
          $(this).addClass("is-loading");
          var quantity = 1;
          if($(this).hasClass("variant")) {
            var id = $(this).attr("data-variant-id");
          } else {
            var id = $(this).closest(".js-product-grid-item").find("select[name='id']").val();
          }
          var properties = {};
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity, properties: properties },
            success: function() {
              unfabled.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              unfabled.refreshCart();
            }
          });
          return false;
        });

        $("body").on("click", ".js-product-out-of-stock a", function () {
          $(".klaviyo-bis-trigger")[0].click();
          return false;
        });

        if($(".js-sticky-bar").length > 0) {
          $(window).scroll(function() {
            if($(window).scrollTop() > $(".js-product-add-to-cart").eq(0).offset().top - 100) {
              $(".js-sticky-bar").addClass("active");
              $(".js-body").addClass("with-sticky");
            } else {
              $(".js-sticky-bar").removeClass("active");
              $(".js-body").removeClass("with-sticky");
            }
          });
        }
      },

      relatedProducts: function() {
        if($(".js-product-recommendations").length > 0) {
          loadRelatedProducts();
          $(window).resize(function() {
            unfabled.wrapRelatedProducts();
          });
        } else {
          unfabled.wrapRelatedProducts();
          $(window).resize(function() {
            unfabled.wrapRelatedProducts();
          });
        }
        function loadRelatedProducts() {
          var productRecommendationsSection = document.querySelector(".js-product-recommendations");
          if (productRecommendationsSection === null) { return; }
          var productId = $(".js-product-recommendations").attr("data-product-id");
          var limit = $(".js-product-recommendations").attr("data-limit");
          var requestUrl = "/recommendations/products?section_id=main-product-related-products&limit="+limit+"&product_id="+productId;
          var request = new XMLHttpRequest();
          request.open("GET", requestUrl);
          request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
              var container = document.createElement("div");
              container.innerHTML = request.response;
              productRecommendationsSection.parentElement.innerHTML = container.querySelector(".js-product-recommendations").innerHTML;
              unfabled.homeProducts();
              unfabled.matchHeight();
              unfabled.wrapRelatedProducts();
            }
          };
          request.send();
        }
      },

      wrapRelatedProducts: function() {
        if($(".js-related-products").length > 0) {
          var left = $(".js-related-products").offset().left;
          $(".js-wrap-related-products").css("margin-left", "-" + left + "px").css("margin-right", "-" + left + "px").css("padding-left", left + "px").css("padding-right", left + "px");
        }
      },

      recentlyViewed: function() {
        if($(".js-recently-viewed-title").length > 0) {
          $(window).resize(function() {
            unfabled.wrapRecentlyViewedProducts();
          });
        }
        Shopify.Products.showRecentlyViewed( { howManyToShow: 12 } );
        setTimeout(function () {
          if($(".js-recently-viewed-product").length > 0) {
            $(".js-no-recently-viewed").hide();
            $(".js-recently-viewed-carousel, .js-recently-viewed-product").removeClass("d-none");
            $(".js-recently-viewed-carousel").owlCarousel({
              loop: false,
              margin: 13,
              nav: true,
              items: 4,
              dots: false,
              autoplay: false,
              responsive: {
                0:{
                  items: 2,
                  margin: 8
                },
                768: {
                  items: 4,
                  margin: 13
                },
                992: {
                  items: 5
                },
                1200: {
                  items: 6
                }
              }
            });
            unfabled.matchHeight();
            unfabled.wrapRecentlyViewedProducts();
          } else {
            $(".js-no-recently-viewed").show();
          }
        }, 2500);
        setInterval(function () {
          $(".js-recently-viewed-product").each(function () {
            if(!$(this).hasClass("active")) {
              var handle = $(this).attr("data-product-handle");
              var that = $(this);
              jQuery.getJSON('/products/' + handle + '.js', function (product) {
                that.find(".js-recently-product-image").attr("src", product.featured_image);
                that.addClass("active");
              });
            }
          });
        }, 550);
      },

      wrapRecentlyViewedProducts: function() {
        var left = $(".js-recently-viewed-title").offset().left;
        $(".js-wrap-recently-viewed-products").css("margin-left", "-" + left + "px").css("margin-right", "-" + left + "px").css("padding-left", left + "px").css("padding-right", left + "px");
      },

      // Pages
      rewardsPage: function() {
        $(".js-open-rewards").click(function () {
          document.getElementById('smile-lite-launcher-frame').contentWindow.document.getElementsByTagName('button')[0].click();
          return false;
        });
      },

      blogPage: function() {
        $("body").on("click", ".js-blog-next-page", function () {
          var href = $(this).attr("data-href");
          $(this).parent().remove();
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $('.js-blog-row').append($(data).find('.js-blog-row').html());
          })
          return false;
        });
        $(".js-blog-tag-page").click(function () {
          $(".js-blog-tag-page").removeClass("active");
          $(this).addClass("active");
          var href = $(this).attr("data-href");
          $('.js-blog-row').html('<div class="col-12 col-md-6 article-grid-item">Loading...</div>');
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $('.js-blog-row').html($(data).find('.js-blog-row').html());
          })
          history.pushState({}, "", href);
          return false;
        });
      },

      shareArticle: function() {
        $(".js-share-twitter").click(function () {
          $("a[data-icon='twitter']").click();
          return false;
        });
        $(".js-share-facebook").click(function () {
          $("a[data-icon='fb']").click();
          return false;
        });
      },

      quiz: function() {
        setInterval(function () {
          if($("div[data-element='oct-quiz-resultWrapper oct-quiz-media']").length > 0) {
            $(".js-quiz-review, .js-quiz-image").removeClass("d-none");
          }
        }, 100);
      },

      helpPages: function() {
        $(".default-page-content table").wrapAll("<div class='table-responsive'></div>");
      },

      // Utilities
      matchHeight: function() {
        $('.js-match-height').matchHeight();
      },

      video: function() {
        $('.js-youtube-video').youtube_background();
        $('.js-vimeo-video').vimeo_player();
        if($('.js-video').length > 0) {
          $(".js-video").each(function () {
            this.controls = false;
            $(this).get(0).play();
          });
        }
      },

      accordion: function() {
        // $(".js-accordion").each(function () {
        //   if(!$(this).hasClass("done")) {
        //     $(this).find(".js-accordion-title").click(function() {
        //       $(this).parent().parent().find(".js-accordion").removeClass("current");
        //       $(this).parent().toggleClass("active").addClass("current");
        //       //$(this).parent().parent().find(".js-accordion:not(.current).active .js-accordion-content").slideToggle(500);
        //       //$(this).parent().parent().find(".js-accordion:not(.current).active").removeClass("active");
        //       $(this).parent().find(".js-accordion-content").slideToggle(500);
        //     });
        //     if($(this).hasClass("active")) {
        //       $(this).find(".js-accordion-content").slideToggle(500);
        //     }
        //   }
        //   $(this).addClass("done");
        // });

        $(".js-accordion").each(function () {
          if (!$(this).hasClass("done")) {
            if ($(this).hasClass("active")) {
              $(this).find(".js-accordion-content").slideToggle(500);
            }
            $(this).addClass("done");
          }
        });

        $(document).on('click', '.js-accordion-title', function() {
          var $accordion = $(this).closest('.js-accordion');
          $accordion.closest('.js-accordion-container').find('.js-accordion').removeClass('current');
          $accordion.toggleClass('active').addClass('current');
          $accordion.closest('.js-accordion-container').find('.js-accordion:not(.current).active .js-accordion-content').slideUp(500);
          $accordion.closest('.js-accordion-container').find('.js-accordion:not(.current).active').removeClass('active');
          $accordion.find('.js-accordion-content').slideToggle(500);
        });
      },

      zoom: function() {
        $(".js-zoomit").each(function () {
          $(this).zoomIt();
        });
      },

      aos: function() {
        AOS.init();
        setInterval(function () {
          $(".aos-init.aos-animate").addClass("animation-done");
        }, 300);
      },


















      gallery: function() {
        $(".js-popup-gallery a:not('.product-grid-item__tag')").jqPhotoSwipe({
          forceSingleGallery: true
        });
        $(".js-mobile-popup-gallery a:not('.product-grid-item__tag')").jqPhotoSwipe({
          forceSingleGallery: true
        });
      },

      quickView: function() {
        $("body").on("click", ".js-open-quickview", function () {
          $(".js-quickview-popup").addClass("active");
          $('#quickview-product').addClass("d-none");
          $(".js-quickview-loader").removeClass("d-none");
          var productUrl = $(this).attr("data-product-url");
          $('#quickview-product').load(productUrl + ' #product-quickview-content', function() {
            $(".js-quickview-loader").addClass("d-none");
            $(this).removeClass("d-none");
            $(this).find("#product-quickview-content").removeClass("d-none").addClass("d-block");
            unfabled.productImages();
            unfabled.productForm();
          });
          return false;
        });
        $(".js-close-quickview-popup").click(function () {
          $(".js-quickview-popup").removeClass("active");
          return false;
        });
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  unfabled.init();
});

function syncCartCounter() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('.js-cart-counter').forEach(el => {
        el.innerText = cart.item_count;
        el.setAttribute('data-counter', cart.item_count);
      });
    });
}

function updateCartCounter(cart) {
  if (!cart || typeof cart.item_count === "undefined") return;

  $(".js-cart-counter")
    .text(cart.item_count)
    .attr("data-counter", cart.item_count)
    .toggleClass("has-items", cart.item_count > 0);
}

document.addEventListener("rebuy:cart.change", function () {
  if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.getCart === "function") {
    updateCartCounter(Rebuy.Cart.getCart());
  }
});


if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      unfabled.init();
    }).on('shopify:section:unload', function() {
      unfabled.init();
    }).on('shopify:section:select', function() {
      unfabled.init();
    }).on('shopify:section:deselect', function() {
      unfabled.init();
    }).on('shopify:block:select', function() {
      unfabled.init();
    }).on('shopify:block:deselect', function() {
      unfabled.init();
    });
}